import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CreateAccountForm, CreateAccountOpportunity, LoginForm } from '@hugendubel/login';
import { _ } from '@hugendubel/utils';
import { useChangeEffect } from '@hugendubel/react-basic';
import { Track, TRACK_ID } from '@hugendubel/tracking_manager';

export enum LoginPageView {
    LOGIN = 'login',
    REGISTRATION = 'register',
}
export const trackingTarget = {
    [LoginPageView.LOGIN]: 'login',
    [LoginPageView.REGISTRATION]: 'registration',
};

const useLoginPageTracking = (view: LoginPageView): void => {
    const viewRef = useRef<LoginPageView>(LoginPageView.LOGIN);
    viewRef.current = view;

    useEffect(() => {
        Track.navigation(TRACK_ID('2021-02-23 04:09:10'), 'COMPONENT', 'OPEN', trackingTarget[LoginPageView.LOGIN]);
        return (): void => {
            Track.navigation(TRACK_ID('2021-02-23 04:09:15'), 'COMPONENT', 'CLOSE', trackingTarget[viewRef.current]); // eslint-disable-line react-hooks/exhaustive-deps
        };
    }, []);

    useChangeEffect(() => {
        Track.navigation(TRACK_ID('2021-02-23 04:09:19'), 'COMPONENT', 'CHANGE', trackingTarget[view]);
    }, [view]);
};

export const LoginPage: React.FC = () => {
    const [view, setView] = useState<LoginPageView>(LoginPageView.LOGIN);

    useLoginPageTracking(view);

    const goToLogin = useCallback(() => setView(LoginPageView.LOGIN), []);
    const goToRegistration = useCallback(() => setView(LoginPageView.REGISTRATION), []);

    if (view === LoginPageView.REGISTRATION) return <CreateAccountForm cancel={goToLogin} isOauthReg={true} />;

    return (
        <>
            <div className="container-fluid">
                <div className={_.classNames('col col-xs-12 col-sm-6', 'customerLogin')}>
                    <LoginForm />
                    <div className="col col-xs-12 col-sm-6 newAccountOrGuest">
                        <CreateAccountOpportunity enterRegistration={goToRegistration} />
                    </div>
                </div>
            </div>
        </>
    );
};
